import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';

import { Select } from '@/Components/UI';

import { StationsFilterProps } from './StationsFilter.types';
import { StationFiltersQueryNames } from './stationsFiltersQueryNames';

export const StationsFilter: FC<StationsFilterProps> = ({ queryName, placeholder, label, children }) => {
    const [query, setQuery] = useSearchParams();

    const handleSelectChange = (value: number | undefined) => {
        if (!value || value === -1) {
            query.delete(queryName);
            setQuery(query);
            return;
        }

        if (queryName === StationFiltersQueryNames.COMPANY) {
            query.delete(StationFiltersQueryNames.STORE_GROUP);
            query.delete(StationFiltersQueryNames.STORE);
        }

        if (queryName === StationFiltersQueryNames.STORE_GROUP) {
            query.delete(StationFiltersQueryNames.STORE);
        }

        query.set(queryName, value.toString());

        setQuery(query);
    };

    return (
        <>
            <Select
                value={Number(query.get(queryName))}
                onChange={handleSelectChange}
                label={label}
                placeholder={placeholder}
                theme="white"
                hideList
                absolute
                autoClose
            >
                <Select.Option id={-1}>All</Select.Option>
                {children}
            </Select>
        </>
    );
};
